const roundDiscountPreviewNumber = (value) => {
  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return 0;
  }

  return Math.round((numericValue + Number.EPSILON) * 100) / 100;
};

export const buildDiscountPreviewFingerprint = (payload = {}) => {
  const visitInfo = payload.visitInfo || {};
  const patientInfo = payload.patientinfo || {};
  const discounts = payload.discounts || {};
  const priceType = visitInfo.priceType || "test_cost_default_etb";

  const couponCodes = Array.isArray(discounts.coupon_codes)
    ? discounts.coupon_codes
      .map((code) => code ? code.toString().trim().toUpperCase() : null)
      .filter(Boolean)
      .sort()
    : [];

  const panelSignature = Array.isArray(payload.panels)
    ? payload.panels
      .filter((panel) => panel && panel.id)
      .map((panel) => ({
        id: panel.id,
        basePrice: roundDiscountPreviewNumber(panel[priceType] ?? panel.test_cost_default_etb ?? panel.test_cost_usd ?? 0),
        defaultPrice: roundDiscountPreviewNumber(panel.test_cost_default_etb),
        manualPrice: roundDiscountPreviewNumber(panel.manual_price ?? panel.custom_price ?? 0),
        discountPercent: panel.discount_percent ?? null,
      }))
      .sort((left, right) => `${left.id}`.localeCompare(`${right.id}`))
    : [];

  if (panelSignature.length === 0) {
    return null;
  }

  const fingerprintPayload = {
    priceType,
    sex: (patientInfo.webSex || "").toString().trim().toUpperCase(),
    dob: patientInfo.webAgeOrDateOfBirth || visitInfo.webAgeInYearMonthDateFormat || null,
    company: visitInfo.webAgencyId || patientInfo.webAgencyId || null,
    branchLocations: [visitInfo.webLocation1, visitInfo.webLocation2, visitInfo.webLocation3]
      .map((value) => (value ? value.toString().trim().toUpperCase() : null))
      .filter(Boolean),
    stat: visitInfo.webStat,
    urgency: visitInfo.webUrgencyCategory,
    extraFees: {
      stat: visitInfo.webExtraFeeForStatTests,
      priority: visitInfo.webExtraFeeForPrioriyQueue,
    },
    couponCodes,
    panels: panelSignature,
  };

  const fingerprint = JSON.stringify(fingerprintPayload);
  return fingerprint && fingerprint !== "{}" ? fingerprint : null;
};